var map = {
	"./account.svg": "ecec",
	"./bills.svg": "5fde",
	"./calendar.svg": "b8bd",
	"./clear.svg": "c8de",
	"./delete.svg": "0d45",
	"./deleteTag.svg": "9b2e",
	"./edit.svg": "daf0",
	"./money_right.svg": "87d5",
	"./noRusult.svg": "8e8f",
	"./ok.svg": "fecb",
	"./statistics.svg": "8ccb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";